import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-point p-3" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "bg-white border border-outline-color px-3 mt-2 round-4" }
const _hoisted_4 = { class: "border-bottom border-outline-color" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-black text-size-14" }, "\n                  ポイント交換\n                ")
], -1)
const _hoisted_6 = { class: "text-gray-05 flex-grow-0 flex-shrink-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-black text-size-14" }, "\n                  ポイント履歴\n                ")
], -1)
const _hoisted_8 = { class: "text-gray-05 flex-grow-0 flex-shrink-0" }

import { computed, onBeforeMount } from "vue";
import Header from "@/components/organisms/common/Header.vue";
import PointCard from "@/components/organisms/mypage/PointCard.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { authStore } from "@/store/auth";
import { accountService } from "@/app/services/AccountService";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const loader = useLoader();
const errorModal = useErrorModal();
const customRouter = useCustomRouter();

onBeforeMount(async () => {
  loader.show();
  try {
    // アカウント情報を更新
    await accountService.updateUserData();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const user = computed(() => authStore.user!);

async function onClickBack() {
  await customRouter.pushIgnoreError({ name: "Mypage" });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      ポイント\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PointCard, { user: user.value }, null, 8, ["user"]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: { name: 'ExchangeCoupon' },
              class: "d-flex justify-content-between align-items-center py-3"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(FeatherIcon, {
                    icon: "chevron-right",
                    size: "1x"
                  })
                ])
              ], undefined, true),
              _: 1
            })
          ]),
          _createTextVNode(),
          _createElementVNode("div", null, [
            _createVNode(_component_RouterLink, {
              to: { name: 'PointHistory' },
              class: "d-flex justify-content-between align-items-center py-3"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(FeatherIcon, {
                    icon: "chevron-right",
                    size: "1x"
                  })
                ])
              ], undefined, true),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})